import { render, staticRenderFns } from "./uzatmayanlar.vue?vue&type=template&id=7ece9df4&"
import script from "./uzatmayanlar.vue?vue&type=script&lang=js&"
export * from "./uzatmayanlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports